import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useGetCompanies } from '@/hooks/useGetCompanies';
import { SelectOptions } from '@/components/ui/SelectOptions';
import * as S from './styles';

const { useWatch, useFormInstance } = Form;

interface CompanyFormItemProps {
	disabled?: boolean;
}

export function CompanyFormItem({ disabled = false }: CompanyFormItemProps) {
	const form = useFormInstance();
	const organization_id = useWatch('organization_id');
	const { data: companies = [], isFetching } = useGetCompanies({ organization_id });

	function handleOnChange(): void {
		form.setFieldValue('sector_id', undefined);
		form.setFieldValue('line_id', undefined);
		form.setFieldValue('workstation_id', undefined);
	}

	const isDisabled = disabled || !organization_id;

	return (
		<S.CustomFormItem name="company_id" label={I18n.get('Industrial site')} labelCol={{ span: 24 }}>
			<SelectOptions
				allowClear
				loading={isFetching}
				disabled={isDisabled}
				options={companies}
				onChange={disabled ? undefined : handleOnChange}
				placeholder={I18n.get('Industrial site')}
			/>
		</S.CustomFormItem>
	);
}
